import ArrowForwardIosRounded from '@mui/icons-material/ArrowForwardIosRounded';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function ArrowForwardIosRoundedIcon(props: FixMe) {
  return <ArrowForwardIosRounded {...props} />;
}

export default ArrowForwardIosRoundedIcon;
